import React, { useEffect } from 'react';
import { Badge } from 'components/ui/badge';
import { useCommunity, useCurrentUser } from 'context/community';
import { usePermissions } from 'context/permissions';
import { getReferenceCommunityId, getToken } from 'services/auth';
import { useChatStore } from '../store/useChatStore';
import { useChatRealtime } from '../hooks/useChatRealtime';
import { useOnlineStatus } from 'context/realtime/onlineStatus';

const formatCount = (count) => (count > 99 ? '99+' : String(count));

export const ChatNavBadge = () => {
    const unreadTotal = useChatStore((state) => state.unreadTotal);
    if (!unreadTotal) {
        return null;
    }
    return <Badge className="ml-1">{formatCount(unreadTotal)}</Badge>;
};

export const AdminChatNavBadge = () => {
    const pendingCount = useChatStore((state) => state.pendingCount);
    if (!pendingCount) {
        return null;
    }
    return <Badge className="ml-1">{formatCount(pendingCount)}</Badge>;
};

export const ChatNavSync = () => {
    const { community } = useCommunity();
    const { connectedParticipants, userId } = useCurrentUser();
    const { hasPermission } = usePermissions();
    const communityId = community?.id || getReferenceCommunityId();
    const isAdmin = typeof hasPermission === 'function' && hasPermission('MANAGE_CHATS');
    const canSync = Boolean(getToken() && communityId && (isAdmin || connectedParticipants?.length));
    const loadConversations = useChatStore((state) => state.loadConversations);
    const loadIntroEnabled = useChatStore((state) => state.loadIntroEnabled);
    const setSelfUserId = useChatStore((state) => state.setSelfUserId);
    const conversations = useChatStore((state) => state.conversations);
    const serverTime = useChatStore((state) => state.serverTime);
    const { seed = () => {}, setServerTime = () => {} } = useOnlineStatus() || {};
    useChatRealtime({ communityId: canSync ? communityId : null, isAdmin });
    useEffect(() => {
        setSelfUserId(userId || null);
    }, [userId, setSelfUserId]);
    useEffect(() => {
        if (canSync) {
            loadConversations(communityId);
            loadIntroEnabled(communityId);
        }
    }, [canSync, communityId, loadConversations, loadIntroEnabled]);
    useEffect(() => {
        if (serverTime) {
            setServerTime(serverTime);
        }
    }, [serverTime, setServerTime]);
    useEffect(() => {
        const entries = [];
        (conversations || []).forEach((conversation) => {
            (conversation.members || []).forEach((member) => {
                if (member.participantId && member.lastActiveAt) {
                    entries.push([member.participantId, member.lastActiveAt]);
                }
            });
        });
        if (entries.length) {
            seed(entries);
        }
    }, [conversations, seed]);
    return null;
};
